import { createSelector } from '@ngrx/store';
import { getLiteralsState } from 'src/app/shared/selectors/literals.selectors';
import { getDragonflyState } from '../reducers';
import { previewListAdapter } from '../reducers/preview-list.reducer';

export const getPreviewListState = createSelector(getDragonflyState, (state) => state?.previewList);

export const getDisplayedColumnKeys = createSelector(getPreviewListState, ({ displayedColumns }) =>
  Object.keys(displayedColumns),
);

export const getDisplayedColumns = createSelector(getPreviewListState, ({ displayedColumns }) => displayedColumns);

export const previewListSelectors = previewListAdapter.getSelectors();

export const getPreviewListData = createSelector(getPreviewListState, previewListSelectors.selectAll);

export const getExcludedColumnKeys = createSelector(getLiteralsState, (literals) => [
  literals.literals['liquid.campaign.lists.preview.sms'],
  literals.literals['liquid.campaign.lists.preview.email'],
  'Preview List Actions',
]);

export const getLoyaltyMemberId = createSelector(getPreviewListState, ({ loyaltyMemberId }) => loyaltyMemberId);

export const getTotalResults = createSelector(getPreviewListState, ({ totalResults }) => totalResults);

export const getItemsNumber = createSelector(getPreviewListState, ({ itemsNumber }) => itemsNumber);

export const getPageIndex = createSelector(getPreviewListState, ({ paginator }) => paginator.pageIndex);

export const getPersonId = createSelector(getPreviewListState, ({ personId }) => personId);

export const getPageSize = createSelector(getPreviewListState, ({ paginator }) => paginator.pageSize);

export const getCampaignAdHocListId = createSelector(
  getPreviewListState,
  ({ campaignAdHocListId }) => campaignAdHocListId,
);
